import React from "react";
import { useParams, Link } from "react-router-dom";

export default function ErrorLink({ err, setShow }) {
  const params = useParams();
  // eslint-disable-next-line no-nested-ternary
  const url = err.workflow
    ? `/library/logic/builder/${params.projectID}${
        err.workflow.UUID ? `/workflow/${err.workflow.UUID}` : ``
      }${
        err.eventListener?.EventType
          ? `/event/${err.eventListener.EventType}`
          : ``
      }${err.eventListener?.UUID ? `/listener/${err.eventListener.UUID}` : ``}${
        err.action?.UUID ? `/action/${err.action?.UUID}` : ``
      }${err.sendList ? `/send-list` : ``}${
        err.configuration ? `/configuration` : ``
      }`
    : err.messageTemplate
    ? `/library/logic/builder/${params.projectID}/message-template/${err.messageTemplate.UUID}/send-list`
    : "";

  return (
    <Link
      className="btn btn-link text-danger text-start p-0 align-baseline"
      to={url}
      onClick={() => setShow?.(false)}
    >
      {err.workflow?.Label ? `${err.workflow.Label} - ` : ""}
      {err.messageTemplate?.Label ? `${err.messageTemplate.Label} - ` : ""}
      {err.error.text}
    </Link>
  );
}
